import React from 'react';
import { get } from 'lodash';
import BigCalendar from 'react-big-calendar';
import moment from 'moment';
import PropTypes from 'prop-types';
import Event from './Event';

const localizer = BigCalendar.momentLocalizer(moment); // or globalizeLocalizer

function CalendarComponent({ onSelectEvent, data, selected }) {
  const onSelect = e => {
    if (onSelectEvent) {
      onSelectEvent(e);
    }
  };
  const eventPropGetter = item => {
    
    if(+get(item,'id') === +get(selected, 'id')){
      return {
        className: 'rbc-selected',
        stye: {}
      }  
    }
    return {
      className: '',
      stye: {}
    }
  }
  return (
    <BigCalendar
      popup
      eventPropGetter={eventPropGetter}
      defaultDate={new Date()}
      events={data}
      components={{
        event: Event(0),
      }}
      showMultiDayTimes
      localizer={localizer}
      views={['month']}
      onSelectEvent={onSelect}
    />
  );
}

CalendarComponent.defaultProps = {
  selected: {}
}

CalendarComponent.propTypes = {
  onSelectEvent: PropTypes.instanceOf(Function).isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
  selected: PropTypes.instanceOf(Object),
};

export default CalendarComponent;
